<template>
  <div class="articleContent">
    <div class="title">
      <span class="title-sty">监管执法情况公示</span>
    </div>
    <div class="announcement">
      <div class="tips">
        <el-button style="font-size: 17px" @click="all()" :type="superviseAll"
          >双随机一公开</el-button
        >
        <el-button style="font-size: 17px" @click="same()" :type="superviseSame"
          >行政处罚公告</el-button
        >
      </div>
      <p
        v-for="item in superviseList"
        :key="item.id"
        style="padding: 0 20px"
        class="clear-float::after"
      >
        <span class="spn">{{ item.kid }}</span>
        <!-- <router-link>{{item.title}}</router-link> -->
        <span class="spnT"
          ><span @click="jump(item)">{{ item.infoTitle }}</span></span
        >
      </p>
      <el-pagination
        style="text-align: center"
        layout="prev, pager, next"
        :total="total"
        :current-page="currentPage"
        :page-size="pagesize"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { URL_PORTAL_SUPERVISIONS } from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
import Vue from "vue";
export default {
  name: "industryManage",
  props: [],
  components: {},
  data() {
    return {
      total: 100,
      superviseAll: "danger",
      supAll: true,
      superviseSame: "success",
      supSame: false,
      // 列表数据
      superviseList: [],
      kid: 1,
      currentPage: 1,
      pagesize: 10,
    };
  },
  computed: {},
  methods: {
    // 请求全部监管事项列表数据
    getList(val) {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        pageSize: this.pagesize,
        pageNumber: this.currentPage,
        superviseType: val,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.post(Url + URL_PORTAL_SUPERVISIONS, params).then((res) => {
        if (res.status == 200) {
          let id;
          this.kid = 1;
          let list = res.data.data;
          list.forEach((item) => {
            id = this.kid++;
            Vue.set(item, "kid", id);
          });
          this.superviseList = res.data.data;
          this.total = res.data.recordsTotal;
        }
      });
    },
    jump(e) {
      if (e.superviseType == "双随机一公开") {
        this.$router.push({
          path: "/home/gov-info-disc",
          query: { id: e.id, type: 1 },
        });
        // window.open(routerJump.href, "_blank");
      }
      if (e.superviseType == "行政处罚公告") {
        this.$router.push({
          path: "/home/gov-info-disc",
          query: { id: e.id, type: 2 },
        });
        // window.open(routerJump.href, "_blank");
      }
    },
    all() {
      this.superviseAll = "danger";
      this.superviseSame = "success";
      this.getList("双随机一公开");
    },
    same() {
      this.superviseAll = "success";
      this.superviseSame = "danger";
      this.getList("行政处罚公告");
    },
  },
  mounted() {
    this.getList("双随机一公开");
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/base";
@import "../../styles/comSty";

p {
  line-height: 30px;
  cursor: pointer;
  .spn {
    height: 30px;
    display: inline-block;
    width: 30px;
    color: #fff;
    background-color: #b71c1c;
    text-align: center;
    margin-right: 10px;
    border-radius: 3px;
    font-size: 14px;
  }
  .spnT {
    display: inline-block;
    width: 95%;
    height: 30px;
    vertical-align: top;
    border-bottom: 1px dashed @border-color;
    color: #606266;
    > span {
      font-size: 16px;
      display: inline-block;
      width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }
  }
}
.spnT:hover {
  border-color: @black;
  color: @theme-color;
}
</style>
